import React from "react";
import {
  IoIosCheckmarkCircle,
  IoIosCheckmarkCircleOutline,
} from "react-icons/io";

export default function NoticeBox({ notice }) {
  const boxColors =
    notice.status === "approved"
      ? "#27AE60"
      : notice.status === "important"
      ? "#F39C12"
      : "#E74C3C";

  return (
    <div className="notice-box" style={{ border: `1px solid ${boxColors}` }}>
      <div className="header" style={{ background: boxColors }}>
        <p>{notice.title}</p>
        <IoIosCheckmarkCircleOutline size={18} />
      </div>
      <div className="content" style={{ background: `${boxColors}12` }}>
        <IoIosCheckmarkCircle color={boxColors} />
        <div>
          <p className="title">{notice.descTitle}</p>
          <p className="sub-text">{notice.desc}</p>
        </div>
      </div>
    </div>
  );
}
